export default __webpack_public_path__ + "static/assets/5599721bb625cd63f3242db503a4e484.png";